<template>
  <div class="testimonials">
    <v-container grid-list-xs>
        <!-- <v-row align="stretch" class="ma-2"> -->
        <v-layout row wrap stretch>
            <!-- <v-col md="4" class="pa-3 d-flex flex-column" v-for="(testimonial) in testimonials" :key="testimonial.id"> -->
            <v-flex md="4" xs12 md6 xl3 pa-2 v-for="(testimonial) in testimonials" :key="testimonial.id">
                <v-card class="elevation-5 flex d-flex flex-column" height='100%'>
                    <v-card-title v-text="testimonial.title"></v-card-title>
                    <v-card-text class="flex" v-text="testimonial.comment"></v-card-text>
                    <v-spacer></v-spacer>
                    <v-card-text v-text="testimonial.info"></v-card-text>
                </v-card>
            <!-- </v-col>
        </v-row> -->
            </v-flex>
        </v-layout>
        <v-btn @click="$router.push({ name: 'post'})"  color="primary" dark fixed bottom right fab>
            <v-icon>mdi-plus</v-icon>
        </v-btn>
    </v-container>
  </div>
</template>

<script>
import firebase from '../configFirebase.js'
export default {
    name: 'Testimonials',
    data(){
        return{
            testimonials:[]
        }
    },
    mounted(){
    firebase.db.collection('testimonials').orderBy('created_at','desc').onSnapshot((snapShot) => {
            this.testimonials=[];
            snapShot.forEach((testimonial)  => {
                this.testimonials.push({
                    id:testimonial.id,
                    info:testimonial.data().info,
                    comment:testimonial.data().comment,
                    title:testimonial.data().title
                })
            });
        });
    }
}
</script>